import React, { useState } from "react";

// Écran de connexion v3 (27/07/2026) — v3 n'en avait aucun jusqu'ici, il ne
// fonctionnait que grâce au cookie de session posé par la v2. Bloquant pour
// le retrait de la v2 (aucun moyen de se reconnecter une fois la session
// expirée, 1h). Même flux que frontend/src/components/Login.jsx (v2) :
// POST /api/login/, session cookie posée par le backend.
export default function Login({ onLogin }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await fetch("/api/login/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      if (r.ok) {
        onLogin();
      } else {
        const body = await r.json().catch(() => ({}));
        setError(body.detail || "Mot de passe incorrect");
      }
    } catch {
      setError("Erreur de connexion au serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 w-full max-w-sm"
      >
        <div className="flex items-center gap-2 mb-6">
          <span className="bg-violet-600 text-white text-xs font-bold px-2.5 py-1 rounded-full">
            ⚡ v3 beta
          </span>
          <span className="text-gray-700 font-semibold">Syrapi</span>
        </div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Mot de passe</label>
        <input
          type="password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="w-full px-3 py-2 border border-gray-300 rounded mb-3 focus:outline-none focus:ring-2 focus:ring-violet-500"
        />
        {error && <p className="text-sm text-red-600 mb-3">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-violet-600 text-white py-2 rounded hover:bg-violet-700 disabled:opacity-50"
        >
          {loading ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
